import client from '@/client/apiClient';
import Game from '@/models/Game/game';

export default class GameService {
  static getGamesByGameWeek(number) {
    return client
      .get(`/game-week/${number}/games`)
      .then((response) => {
        const { clubGames, nationalTeamGames } = response.data;
        return {
          clubGames: Game.createCollectionFromObject(clubGames),
          nationalTeamGames: Game.createCollectionFromObject(nationalTeamGames, true),
        };
      });
  }
};
